AddMemberToTeamView = require 'app/scripts/views/member/add-to-team-popover-view'
Alerts = require 'app/scripts/views/lib/alerts'
Auth = require 'app/scripts/db/auth'
ChangeRolePopoverView = require 'app/scripts/views/member/change-role-popover-view'
Confirm = require 'app/scripts/views/lib/confirm'
Controller = require 'app/scripts/controller'
{ featureFlagClient } = require '@trello/feature-flag-client'
MemberMiniProfileView = require 'app/scripts/views/member-menu-profile/member-mini-profile-view'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
$ = require 'jquery'
_ = require 'underscore'
l = require 'app/scripts/lib/localize'
{ logError } = require 'app/scripts/debug/log-error'
templates = require 'app/scripts/views/internal/templates'
{ maybeDisplayOrgMemberLimitsError } = require 'app/scripts/views/organization/member-limits-error'
{ dontUpsell } = require '@trello/config'

module.exports = class BoardMemberMenuView extends MemberMiniProfileView
  className: 'board-member-menu'

  initialize: ->
    @board = @options.board
    # If invitations permissions change while menu is open, rerender menu
    # as remove permissions may have changed
    @listenTo @board, 'change:prefs', @render

    super

  events:
    'click .js-remove-member': 'removeMember'
    'click .js-add-to-team': 'addMemberToTeam'
    'click .js-add-to-team a': 'addMemberToTeamUpgrade'
    'click .js-change-role': 'changeRole'
    'click .js-view-member-activity': 'viewMemberActivity'

  addMemberToTeamUpgrade: (e) ->
    e.stopPropagation()
    if !dontUpsell
      e.preventDefault()
      Controller.navigate(e.target.pathname, { trigger: true })

  renderMenu: ->
    data = _.extend @model.toJSON(),
              @board.premiumFeatures?(),
              @model.getMembershipData(@board)

    org = @board.getOrganization()

    data.boardProfileUrl = Controller.getMemberBoardProfileUrl(@model.get('username'), @board.id)

    memberType = @board.getMemberType(@model, { ignoreEntAdminStatus: true })
    data.canInviteMemberToTeam = org and @canInviteMemberToTeam(org)
    data.isGhost = memberType == 'virtual'
    data.type = l(['member types', memberType])
    data.isTemplate = @board.isTemplate()
    data.isFreeTeam = org && !org.isPremium()
    data.allAdminsEnabled = org?.get('allAdminsEnabled')
    data.orgBillingUrl = org?.getBillingUrl()

    if memberType in ['superadmin', 'deactivated']
      data.canChangeRole = false

    @$el.append(
      templates.fillMenu(
        require('app/scripts/views/templates/member_on_board_menu'),
        data,
        { editable: @board.editable(), owned: @board.owned() }
      )
    )

    @

  viewMemberActivity: ->
    PopOver.hide()

  canInviteMemberToTeam: (org) ->
    if org.hasActiveMembership(@model)
      return false

    me = Auth.me()
    isTeamAdmin = org.ownedByMember(me)

    isEnterprise = org.belongsToRealEnterprise()

    idEnterprise = org.get('idEnterprise')
    isEnterpriseAdmin = me.get('idEnterprisesAdmin')?.indexOf(idEnterprise) >= 0

    isTeamAdmin or (isEnterprise and isEnterpriseAdmin)

  changeRole: (e) ->
    Util.stop(e)
    PopOver.pushView
      view: new ChangeRolePopoverView({ @model, parent: @board, @modelCache })

    return

  removeMember: (e, options) ->
    Util.stop(e)

    Confirm.pushView @model.removeMembershipConfirmationKey(@board),
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        @board.removeMember(@model)
        PopOver.hide()

  showError: (message) ->
    logError new Error("Unknown server error message '#{message}'")
    errorMessage = l(['server error', 'unknown'])
    Alerts.showLiteralText(errorMessage, 'error', 'alert', 5000)

  addMemberToTeam: (e, options) ->
    Util.stop(e)

    org = @board.getOrganization()

    isEnterprise = org.belongsToRealEnterprise()
    isBC = org.isBusinessClass()

    if isEnterprise or isBC
      PopOver.pushView
        # limits are checked in AddMemberToTeamView
        view: new AddMemberToTeamView({
          isBC
          isEnterprise
          @model
          org
        })
    else
      if maybeDisplayOrgMemberLimitsError($(e.target), org, @model)
        return

      org.addMember(@model).then =>
        PopOver.hide()
      .catch (err) =>
        @showError(err.message)
        PopOver.hide()

    return
